import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { HomePageWidgetBlueprint } from '@backstage/plugin-home-react/alpha';
import { InfoCard } from '@backstage/core-components';
import { Box, Typography, Divider } from '@material-ui/core';
import { CmsWidget } from './CmsWidget';
import { LogoFull } from '../nav/LogoFull';

function BemVindoContent() {
  return (
    <Box p={1}>
      <Box mb={2} display="flex" alignItems="center" height={40}>
        <LogoFull />
      </Box>
      <Divider />
      <Box mt={2}>
        <Typography variant="body2" paragraph>
          Este portal centraliza o catálogo de serviços, ferramentas de
          conteúdo e observabilidade da plataforma. Use o menu lateral para
          navegar entre as seções.
        </Typography>
        <Typography variant="body2" color="textSecondary">
          Edite <code>packages/app/src/modules/home/homeModule.tsx</code> para
          personalizar esta página com texto, imagens e links do seu time.
        </Typography>
      </Box>
    </Box>
  );
}

const bemVindoWidget = HomePageWidgetBlueprint.make({
  name: 'bem-vindo',
  params: {
    name: 'BemVindo',
    title: 'lemon.energy Platform',
    description: 'Portal interno de engenharia',
    components: async () => ({
      Content: () => (
        <InfoCard noPadding>
          <BemVindoContent />
        </InfoCard>
      ),
    }),
  },
});

const cmsWidget = HomePageWidgetBlueprint.make({
  name: 'cms-access',
  params: {
    name: 'CmsAccess',
    title: 'CMS',
    description: 'Editor de conteúdo com acesso ao builder e WYSIWYG',
    components: async () => ({
      Content: CmsWidget,
    }),
  },
});

export const homeModule = createFrontendModule({
  pluginId: 'home',
  extensions: [bemVindoWidget, cmsWidget],
});
